export default "__VITE_ASSET__BqQ7r0U8__"